
class Abm {

    constructor({table, fields, endpoint, serverSide}) {
        let self = this;
        return (async () => {
            self.table = table;
            self.showClosed = false;
            self.serverSide = serverSide;
            self.endpoint = endpoint;
            self.search = null;
            self.fields = fields;
            if (!fields) {
                let options = await getModuleFieldsOptions(table);
                self.fields = options.fields;
            }
            self.dataList = [];
            self.listValues = {};
            self.hasClosed = self.getHasClosed();
            self.dataFilter = null;
            self.notifications = {
                errors: [],
                message: null,
                warning: null,
            }
            self.tableSpec = null;
            self.serverFields = null;
            self.fieldOptions = await tools.calculateFieldOptions(self.abmFields, serverSide);
            self.columnsNames = self.getColumnsNames();
            self.headings = self.getHeadings();
            self.templates = self.getTemplates();
            return self;
        })();
    }


    get abmFields () {
        return tools.getAbmFields(this.fields);
    }

    getHasClosed () {
        for (let f of this.fields) {
            if (f === 'Closed' || f.name === 'Closed') return true;
        }
        return false;
    }

    async fetchList (tableName, endpoint, filters, refresh) {
        let e = endpoint ? endpoint: this.endpoint;
        let list;
        list = await tools.fetchTable(tableName, e, filters, refresh, null, this.showClosed);
        if (list){
            this.dataList = _.each(_.filter(list, (r) => {
                if (r.Closed && !this.showClosed) return false;
                if (this.dataFilter) {
                    if (!this.dataFilter(r)) return false;
                }
                return true;
            }), (c) => {
                c.original_id = c.id
            })
        }
    }

    getValues () {
        this.listValues = {};
        for (let field of this.abmFields) {
            for (let row of this.dataList) {
                let r = tools.getDisplayValue(row, field, this.serverSide, this.fieldOptions);
                if (!this.listValues[[field.name, row[field.name]]]) {
                    this.listValues[[field.name, row[field.name]]] = r;
                }
            }
        }
    }

    abmList () {
        return tools.abmList(this);
    }

    getColumnsNames () {
        let res = [];
        for (let f of this.abmFields) {
            if (f.type=='password') continue;
            if (f.hideFromList) continue;
            if (f.hidden) continue;
            if (f.editor=='tab') continue;
            //if (f.editor=='button') continue;
            if (f.editor=='component') continue;
            if (typeof f.editor === 'object') continue;
            if (Array.isArray(f.editor)) continue;
            res.push(f.name);
        }
        return res;
    }

    getHeadings () {
        let res = {};
        for (let f of this.abmFields) {
            if (f.type=='password') continue;
            if (f.hidden) continue;
            if (f.label) {
                res[f.name] = tr(f.label);
            }
        }
        return res;
    }

    getTemplates () {
        let res = {}
        let self = this;
        for (let field of this.abmFields) {
            res[field.name] = function(t, row) {
            //console.log(field.name, self.listValues)
                return tools.getDisplayValue(row, field, self.serverSide, self.fieldOptions);
                if (self.listValues) {
                    //return self.listValues[[field.name, row[field.name]]]
                } else {
                    return tools.getDisplayValue(row, field, self.serverSide, self.fieldOptions);
                }
            }
        }
        return res;
    }

    async requestFunction (data) {
        let f = Object.assign({}, data)
        f.fields = _.filter(this.abmFields, (r) => {
            return this.columnsNames.indexOf(r.name)>-1;
        });
        return await api.get(this.endpoint, {getCount: true, toJSON: true,
            data: JSON.stringify(f)}).then(function(d) {
            let dataList = _.each(d.query, (c) => {
                c.original_id = c.id;
            })
                return {data: dataList, count: d.count};
            }).catch(function(e) {
                this.dispatch('error', e);
            }.bind(this));
    }


}

export default Abm;
window.abm = Abm;
